<template>
  <div v-if="activeVenue">
    <vs-row>
      <!-- <h3 class="mr-4">Venue visits</h3> -->
      <vs-button
        @click="activeTab = 0"
        :color="activeTab == 0 ? 'success' : 'rgb(80, 80, 80)'"
        :type="activeTab == 0 ? 'filled' : 'border'"
        class="mr-3 selection-button"
        >{{ activeVenue.name }}</vs-button
      >
      <vs-button
        @click="activeTab = 1"
        v-if="hasPermission('vp.vp.lists.venuevisits.overview')"
        :color="activeTab == 1 ? 'success' : 'rgb(80, 80, 80)'"
        :type="activeTab == 1 ? 'filled' : 'border'"
        class="mr-3 selection-button"
        >Overview</vs-button
      >
    </vs-row>

    <div v-if="activeTab == 0" class="tab-general md:ml-4 md:mt-0 ml-0">
      <venue-visits />
    </div>

    <div v-if="activeTab == 1" class="tab-general md:ml-4 md:mt-0 ml-0">
      <visits-overview />
    </div>

    <!-- <vs-tabs position="bottom" :key="isSmallerScreen" id="nested-tabs">
      <vs-tab
        icon-pack="feather"
        icon="icon-activity"
        :label="!isSmallerScreen ? activeVenue.name : ''"
      >
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <venue-visits />
        </div>
      </vs-tab>
      <vs-tab
        icon-pack="feather"
        icon="icon-bar-chart-2"
        :label="!isSmallerScreen ? 'Venue overview' : ''"
      >
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <visits-overview />
        </div>
      </vs-tab>
    </vs-tabs> -->
  </div>
</template>

<script>
import VisitsOverview from "./VisitsOverview.vue";
import VenueVisits from "./VenueVisits.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    VisitsOverview,
    VenueVisits,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  methods: {},
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
    }),

    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    loading() {
      return (
        this.$store.state.venues.loading || this.$store.state.venues.allLoading
      );
    },
  },
  watch: {
    // eslint-disable-next-line
    loading: function (nS, ds) {
      if (nS) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
  },

  created() {},
};
</script>

<style lang="scss">
</style>
